import { Component, HostListener, HostBinding, ViewContainerRef, ViewChild,ElementRef } from '@angular/core';
import { StorageService } from '../storage-service/storage.service';
import { Router } from '@angular/router';
import { HelpService } from '../help-service/help.service';
import { EulaService } from '../eula/eula.service';
import { AuthenticationService } from '../authentication-service/authentication.service';
import { OxeModelService } from '../oxe-model-service/oxe-model.service';
import { DialogService } from '../confirm-dialog/dialog.service';
import { EventService } from "../config-eventlogs/event.service";
import { IndexedDBService } from "../indexed-db-service/indexed-db.service";
import { EventLogModel } from "../config-eventlogs/eventlog-model";

@Component({
    selector: 'wbm-home-header',
    templateUrl: './home-header.component.html',
    styleUrls: ['../../assets/theme/css/HomeHeader.css']

})
export class HomeHeaderComponent {
    @HostBinding() class = 'flex-container flex-align-center flex-item-none';

    public username: string;
    public loginDate: string;
    public hostName: string;
    private _isConfigurationPanelActive: boolean = true;
    private _isHelpPanelActive: boolean = false;
    private _isEulaPopupActive: boolean = false;
    isEventLogClicked: boolean;
    targetEvent: EventTarget;
    @ViewChild('eventBtn', { static: false }) dataContainer!: ElementRef;
    @HostListener('window:beforeunload')
    confirmDiscadChangesOnClose() {
        if (this._oxeModelService.isSomethingModified()) {
            return window.confirm('confirm-discard');
        }
        return true;
    }


    constructor(
        private _router: Router,
        private _storage: StorageService,
        private _helpService: HelpService,
        private _authService: AuthenticationService,
        private _oxeModelService: OxeModelService,
        private _dialogService: DialogService,
        private _eulaService: EulaService,
        private _eventService: EventService,
        private _indexDbService: IndexedDBService,
        vcRef: ViewContainerRef,
        private eRef:ElementRef
    ) {
        this.username = this._storage.retrieveUsername();
        this.loginDate = this._storage.retrieveLoginDate();
        this.hostName = this._storage.retrieveHostName();

    };


    public navigateToConfiguration(): void {
        this._router.navigate(['home/configuration']);
        this._isConfigurationPanelActive = true;
    }

    public navigateToMaintenance(): void {
        this._router.navigate(['home/maintenance']);
        this._isConfigurationPanelActive = false;
    }

    public clickHelpBtn() {
        if (this._helpService.isHelpDisplayed()) {
            this._isHelpPanelActive = false;
            return this._helpService.enableHelpDisplay(false);
        } else {
            this._isHelpPanelActive = true;
            this._eventService.enableEventDisplay(false);
            return this._helpService.enableHelpDisplay(true);
        }
    }

    public clickEventLogBtn() {
        this._eventService.errorLogLength = 0;
        if (this._eventService.isEventDisplayed()) {
             this.isEventLogClicked = false;
            return this._eventService.enableEventDisplay(false);
        } else {
            this.isEventLogClicked = true;
            this._helpService.enableHelpDisplay(false);
            return this._eventService.enableEventDisplay(true);
        }


    }



    public clickAboutBtn() {
        if (this._eulaService.isEulaDisplayed()) {
            this._isEulaPopupActive = false;
            return this._eulaService.enableEulaDisplay(false);
        } else {
            this._isEulaPopupActive = true;
            return this._eulaService.enableEulaDisplay(true);
        }
    }

    public isHelpAvailable() {
        return this._helpService.isHelpLoaded();
        //return true;
    }

    public clickLogoutBtn() {
        if (this._oxeModelService.isSomethingModified()) {
            this._dialogService.confirm('confirm-discard')
                .then(() => {
                    this._authService.logout();
                })
                .catch(() => { });
        } else {
            this._authService.logout();
        }
    }
}
